import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "Report/";

const getTimeLogReport = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'GetTimeLogReport', model, constants.REQUIRE_INTERCEPTORS);

export {
    getTimeLogReport
}